import type { IAnalyticsFilter, IAnalyticsParams } from '~/types/analytic'
import type { IDateRange } from '~/types/date'

import config from '~/config'
import { request } from '~/utils/request'

const getCallParams = ({
  appIds,
  dateRange,
  filters,
}: {
  appIds?: string[]
  dateRange?: IDateRange
  filters: IAnalyticsFilter[]
}) => {
  return filters.every((filter) => filter?.value?.length === 1 && filter.value[0] === '')
    ? { filter: dateRange || {} }
    : {
        breakdowns: filters.map(({ key, value }) => {
          return !value?.includes('')
            ? {
                condition_type: 'include',
                distinct: false,
                key,
                values: value,
              }
            : {}
        }),
        filter: dateRange || {},
        ...(appIds ? { applications_ids: appIds } : {}),
      }
}

export const getAnalytics = <T = any>(appIds: string[], params: IAnalyticsParams): Promise<T> => {
  return request({
    data: getCallParams({ dateRange: params.dateRange, filters: params.filters }),
    method: 'POST',
    transformResponse: (data) => {
      const parsedData = JSON.parse(data)

      if (parsedData && parsedData.DataPoints) {
        return {
          data: parsedData.DataPoints,
        }
      }

      return parsedData
    },
    url: `${config.VERSIONS_API}/application/${appIds}/analytics/${params.feature}`,
  })
}

export const getBusinessReportAnalytics = <T = any>(appId: string, params: IAnalyticsParams): Promise<T> => {
  return request({
    data: getCallParams({ dateRange: params.dateRange, filters: params.filters }),
    method: 'POST',
    transformResponse: (data) => {
      const parsedData = JSON.parse(data)

      if (parsedData && parsedData.DataPoints) {
        return {
          data: parsedData.DataPoints,
        }
      }

      return parsedData
    },
    url: `${config.VERSIONS_API}/application/${appId}/analytics/business-report/${params.feature}`,
  })
}

export const getAnalyticsCacheState = (): Promise<{ refreshed_at_ts: number }> => {
  return request({
    url: `${config.VERSIONS_API}/cache/last-refresh`,
  })
}
